import { Card, Layout, Form, Input, Button, Modal, notification, Skeleton } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getProfile, updateProfile } from '../../../controllers/store/actions/profile/profile-actions';
import ProfileHeader from './Profile-Header';
import MenuBar from '../../components/Menu/MenuBar';
import Footer from '../../components/Footer/Footer';
import store from '../../../controllers/store';
import { ProfileMessages, TokenType } from '../..';
import { IconType} from 'antd/es/notification/interface';
import { ActionsetUser } from '../../../controllers/store/actions/user/actions';

const { Header, Content } = Layout;
const dispatch = store.dispatch

const Profile: React.FC = () => {
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const user = useSelector((state: any) => state.user.user);
    const profile = useSelector((state: any) => state.profile);

    useEffect(() => {
        dispatch(getProfile());
    }, [user.me.id]);

    useEffect(() => {
        if (profile) {
            form.setFieldsValue(profile.profile);
        }
    }, [form, profile]);

    const onFinish = async (values: any) => {
        Modal.confirm({
            title: ProfileMessages.Title,
            content: ProfileMessages.ProfileConfirmMessage,
            cancelText : 'Cancelar',
            okText : 'Guardar',
            okButtonProps :{ type:'default'},
            onOk: () => { 
                try {
                    dispatch(updateProfile(user.me.id, values));
                    api.info({
                        type: TokenType.success as IconType,
                        message: ProfileMessages.Title,
                        description: ProfileMessages.ProfileUpdateSuccessMessage,
                        placement : 'top',
                        onClose : ()=>{
                            dispatch(getProfile());
                        }
                    });
                } catch (error) {
                    api.error({
                        type: TokenType.success as IconType,
                        message: ProfileMessages.Title,
                        description: ProfileMessages.ProfileUpdateErrorMessage,
                        placement : 'top'
                    });
                }
            },
            onCancel: () => { },
            footer: (_, { OkBtn, CancelBtn }) => (<><CancelBtn /><OkBtn /></>
            ),
        });
    };

    return (
        <Layout className="profile-layout">
             {contextHolder}
            <MenuBar />
            <Header className="bg-header-profile" />
            <Content style={{
                padding: 44,
                minHeight: 280,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <Card className="profile-card">
                    <Skeleton loading={profile.isLoading} active className='full-width'>
                    <ProfileHeader user={profile.profile} />
                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Form.Item label="Nombres" name="first_name">
                            <Input placeholder="Nombres" />
                        </Form.Item>
                        <Form.Item label="Apellidos" name="last_name">
                            <Input placeholder="Apellidos" />
                        </Form.Item>
                        <Form.Item label="Correo electrónico" name="email">
                            <Input disabled placeholder="Correo electrónico" />
                        </Form.Item>
                        <Form.Item label="Teléfono" name="phone">
                            <Input placeholder="Teléfono" />
                        </Form.Item>
                        <Form.Item label="Dirección" name="location">
                            <Input placeholder="Dirección" />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">Guardar</Button>
                        </Form.Item>
                    </Form>
                    </Skeleton>
                </Card>
            </Content>
            <Footer />
        </Layout>
    );
}

export default Profile;
